import React from 'react'
import { useTranslation } from 'react-i18next'
import { CurrentPlanDetailsRow } from '../CurrentPlanDetails.styled'

type Props = {
  endDate: string
  productName: string
}

export const TrailPerProductSubscriptionDetails = ({ endDate, productName }: Props) => {
  const { t } = useTranslation('accountSettings')

  return (
    <>
      <CurrentPlanDetailsRow>
        {t('plan_details.trail_per_product', {
          productName,
          endDate,
        })}
      </CurrentPlanDetailsRow>
    </>
  )
}
